import Alpine from 'alpinejs'
import { convertObjectNumbersToString } from '../helpers/convertObjectNumbersToString'
import { pushDataLayer } from '../helpers/pushDataLayer'
import { Endpoints } from '../site'

// Initial data, used to reset the form.
const initialFormData = () => ({
  first_name: '',
  last_name: '',
  email: '',
  customer_number: '',
  accept_term: false,
  recaptcha_token: '',
  current_url: '',
})

Alpine.data('parkingConditionsForm', (url: string) => ({
  formData: initialFormData(),
  submitted: false,
  errors: null,
  errorMessage: null,
  currentUrl: url,

  submit() {
    const thisData = this

    if (thisData.formData.current_url === '') {
      thisData.formData.current_url = thisData.currentUrl
    }
    // google reCaptcha script to get token
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(`${import.meta.env.MIX_RECAPTCHA_SITE_KEY as string}`, {
          action: 'parking_conditions_form',
        })
        .then(function (token) {
          // token to reCaptcha_token in formData.
          thisData.formData.recaptcha_token = token

          fetch(`${import.meta.env.MIX_API_BASE as string}${Endpoints.parkingConditionsForm}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(convertObjectNumbersToString(thisData.formData)),
          }).then((response) => {
            if (response.ok) {
              pushDataLayer({
                event: 'parking_conditions_form',
                mail: thisData.formData.email,
                formSubject: 'Bekræft nye parkerings betinelser',
              })
              thisData.submitted = true
              thisData.errors = null
              thisData.errorMessage = null
              thisData.formData = initialFormData()
              window.dispatchEvent(
                new CustomEvent('notice', {
                  detail: {
                    type: 'success',
                    text: 'Tak for din bekræftelse på at have læst, forstået og accepteret de ændrede vilkår og priser.',
                  },
                })
              )
            } else {
              thisData.submitted = false
              response.json().then((data) => {
                thisData.errors = data.errors
                thisData.errorMessage = data.message
                window.dispatchEvent(
                  new CustomEvent('notice', { detail: { type: 'error', text: data.message } })
                )
              })
            }
          })
        })
    })
  },

  init() {},
}))
